<p-button [text]="text" [disabled]="disabled" [label]="label"  [type]="type" [icon]="icon" styleClass="p-button-rounded m-2 p-2"></p-button>
